// extracted by mini-css-extract-plugin
module.exports = {"HowItWorks":"_2tx6m","Heading":"_2oo9v","Steps":"_1DbV0","Step":"_3uOv_","IconContainer":"Fk0_0","ContentContainer":"_1Dalt"};